import styled from 'styled-components';

import { Select, SelectOption } from '@components/select';
import { Stack } from '@components/stack';
import { useScopedTranslate } from '@locale/translate';
import { pxToRem } from '@utils/converters';

export type CurrencySelectorProps = {
  value: string;
  isLocked: boolean;
  onChange: (currency: string) => void;
};

export const CurrencySelector = ({ value, isLocked, onChange }: CurrencySelectorProps) => {
  const { t } = useScopedTranslate(locale);

  const baseOptions: SelectOption[] = [
    { label: t('usdTitle'), value: 'USD' },
    { label: t('eurTitle'), value: 'EUR' },
    { label: t('gbpTitle'), value: 'GBP' },
  ];

  const hasValueOption = baseOptions.some((option) => option.value === value);
  const options = hasValueOption ? baseOptions : [...baseOptions, { label: value, value }];

  return (
    <SelectContainer data-testid="currency-selector">
      <Select
        value={value}
        onChange={onChange}
        options={options}
        isDisabled={isLocked}
        isClearable={false}
      />
    </SelectContainer>
  );
};

const SelectContainer = styled(Stack).attrs({
  orientation: 'horizontal',
})({
  width: pxToRem(160),
  '> div': {
    width: '100%',
  },
});

const locale = {
  en: {
    usdTitle: 'USD',
    usdLabel: 'USD • US Dollars',
    eurTitle: 'EUR',
    eurLabel: 'EUR • Euros',
    gbpTitle: 'GBP',
    gbpLabel: 'GBP • British Pounds',
  },
};
